'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lock = function Lock(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react2.default.createElement(
    'svg',
    { width: size, height: size, viewBox: '0 0 20 20' },
    _react2.default.createElement('path', {
      d: 'M7.778 9.556h4.444V7.889c0-.614-.217-1.137-.65-1.571A2.141 2.141 0 0 0 10 5.667c-.613 0-1.137.217-1.571.65a2.141 2.141 0 0 0-.651 1.572v1.667zm7.222.833v5a.804.804 0 0 1-.243.59.804.804 0 0 1-.59.243H5.833a.804.804 0 0 1-.59-.243.804.804 0 0 1-.243-.59v-5c0-.232.081-.428.243-.59a.804.804 0 0 1 .59-.243h.278V7.889c0-1.065.382-1.98 1.146-2.743C8.02 4.382 8.935 4 10 4s1.98.382 2.743 1.146c.764.764 1.146 1.678 1.146 2.743v1.667h.278c.231 0 .428.08.59.243a.804.804 0 0 1 .243.59z',
      fill: color,
      fillRule: 'evenodd'
    })
  );
};

Lock.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

Lock.defaultProps = {
  size: 20,
  color: '#b5b0a2'
};

exports.default = Lock;